/*
The seven generic case stages and their sub-statuses.

The backend maps raw ticket statuses onto these labels (`stage` on the ticket
list response). The sub-statuses below are presentation-only - no endpoint
reports which sub-step a case sits on yet.
*/

export const STAGES = [
  {
    key: "created",
    label: "Created",
    subStatuses: ["Case created"],
  },
  {
    key: "delivery",
    label: "Delivery",
    subStatuses: [
      "Delivery label scanned by courier",
      "Delivery status: 'Delivered'",
    ],
  },
  {
    key: "processing",
    label: "Processing",
    subStatuses: ["Assigned to repairer", "Service type selected"],
  },
  {
    key: "pending_approval",
    label: "Pending Approval",
    subStatuses: ["Assigned for approval"],
  },
  {
    key: "post_approval",
    label: "Post Approval",
    subStatuses: ["Approver approved"],
  },
  {
    key: "finalising",
    label: "Finalising",
    subStatuses: [
      "Outcome recorded",
      "Dispatch label organised",
      "Notice of dispatch sent",
    ],
  },
  {
    key: "complete",
    label: "Complete",
    subStatuses: ["Dispatched"],
  },
];

export const COMPLETION_OUTCOMES = [
  "Repair",
  "Replacement",
  "Refund",
  "Rejected",
  "Voided",
  "Cancelled",
];

// Tints per stage, keyed by stage key. Used for the list badge and the detail header.
export const STAGE_TONES = {
  created: { bg: "#e8f0fe", fg: "#1a56db" },
  delivery: { bg: "#e0f2fe", fg: "#0369a1" },
  processing: { bg: "#fef3c7", fg: "#b45309" },
  pending_approval: { bg: "#f3e8ff", fg: "#7c3aed" },
  post_approval: { bg: "#e0e7ff", fg: "#4338ca" },
  finalising: { bg: "#ccfbf1", fg: "#0f766e" },
  complete: { bg: "#dcfce7", fg: "#15803d" },
};

const NEUTRAL_TONE = { bg: "#eef0f3", fg: "#64748b" };

/*
Tolerant lookup - the API sends the human label ("Pending Approval"), but an
unmapped status could send anything. Returns -1 rather than throwing so callers
can render a dash.
*/
export const stageIndex = function (label) {
  if (!label) return -1;
  const needle = String(label).trim().toLowerCase();
  for (let i = 0; i < STAGES.length; i += 1) {
    if (
      STAGES[i].label.toLowerCase() === needle ||
      STAGES[i].key.toLowerCase() === needle
    ) {
      return i;
    }
  }
  return -1;
};

export const stageTone = function (label) {
  const index = stageIndex(label);
  if (index === -1) return NEUTRAL_TONE;
  return STAGE_TONES[STAGES[index].key] || NEUTRAL_TONE;
};

// Type column tints - the API sends one of these three strings in `type_label`.
export const TYPE_TONES = {
  DOA: { bg: "#fef3c7", fg: "#b45309" },
  "In-Warranty": { bg: "#e0f2fe", fg: "#0369a1" },
  "Out-of-Warranty": { bg: "#f1f5f9", fg: "#475569" },
};

export const typeTone = function (value) {
  return TYPE_TONES[value] || NEUTRAL_TONE;
};

export default STAGES;
